import { useState } from "react";
import { toast } from "sonner";
import AppShell from "@/components/AppShell";
import { errMsg, useApi } from "@/lib/api";
import { useMe } from "@/context/MeContext";

export const useFixCard = () => {
  const api = useApi();
  const { me } = useMe();
  const [busy, setBusy] = useState(false);
  const fix = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/payments/checkout", { lookup_key: me.membership?.lookup_key || "ahu_monthly", origin_url: window.location.origin });
      window.location.href = data.checkout_url;
    } catch (e) { toast.error(errMsg(e)); setBusy(false); }
  };
  return [fix, busy];
};

export const HeldPlan = ({ plan }) => {
  const [fix, busy] = useFixCard();
  return (
    <AppShell>
      <div className="ahu-card p-6 sm:p-10 fade-in" data-testid="plan-payment-hold">
        <p className="eyebrow mb-3">Your Action Plan is ready</p>
        <h1 className="text-2xl sm:text-3xl leading-snug">{plan.title}</h1>
        <p className="mt-4 text-ink leading-relaxed">We couldn't take your first membership payment. Please update your card and your plan will open straight away.</p>
        <button className="btn-charcoal mt-8 w-full sm:w-auto sm:min-w-[240px]" disabled={busy} onClick={fix} data-testid="update-card-btn">{busy ? "Opening checkout" : "Update my card"}</button>
        <p className="mt-5 text-sm text-ink-soft">Need a hand? Email support@teahusolutions.com.</p>
      </div>
    </AppShell>
  );
};
